import * as React from "react";

function SvgSuitcase(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 22"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M21.6 3.67h-1.2V22h1.2a2.43 2.43 0 002.4-2.44V6.11a2.43 2.43 0 00-2.4-2.44zM0 6.11v13.45A2.43 2.43 0 002.4 22h1.2V3.67H2.4A2.43 2.43 0 000 6.11zm16.2-5A9.4 9.4 0 0012 0a9.16 9.16 0 00-4.2 1.11v2.56h-3V22h14.4V3.67h-3zm-1.8 2.56H9.6V2a5.31 5.31 0 012.4-.53 5.53 5.53 0 012.4.53z" />
    </svg>
  );
}

const MemoSvgSuitcase = React.memo(SvgSuitcase);
export default MemoSvgSuitcase;
